
(function () {
  'use strict';

  var AZ = 24 * Math.PI / 180;   
  var EL = 15 * Math.PI / 180;   
  var CA = Math.cos(AZ), SA = Math.sin(AZ), CE = Math.cos(EL), SE = Math.sin(EL);
  var MAROON = '#933744';
  var SW = 1.4;     
  var SW2 = 1;      
  var PAD_TOP = 3, PAD_FLOOR = 4;
  var N = 72;       
  var seq = 0;

  function P(p) { var x1 = p[0] * CA + p[2] * SA, z1 = -p[0] * SA + p[2] * CA; return [x1, p[1] * CE - z1 * SE]; }
  function facing(n) { var z1 = -n[0] * SA + n[2] * CA; return z1 * CE + n[1] * SE; }

  function circle3(c, u, w, r, n) {
    var out = [];
    n = n || N;
    for (var i = 0; i < n; i++) {
      var t = i / n * Math.PI * 2, ct = Math.cos(t), st = Math.sin(t);
      out.push({
        p: [c[0] + r * (ct * u[0] + st * w[0]), c[1] + r * (ct * u[1] + st * w[1]), c[2] + r * (ct * u[2] + st * w[2])],
        n: [ct * u[0] + st * w[0], ct * u[1] + st * w[1], ct * u[2] + st * w[2]]
      });
    }
    return out;
  }
  var X = [1, 0, 0], Y = [0, 1, 0], Z = [0, 0, 1];
  function ringZ(cx, cy, z, r) { return circle3([cx, cy, z], X, Y, r); }   
  function ringY(cx, y, cz, r) { return circle3([cx, y, cz], X, Z, r); }   
  function pts(ring) { return ring.map(function (q) { return P(q.p); }); }

  function frontArc(ring) {
    var n = ring.length, vis = ring.map(function (q) { return facing(q.n) >= 0; }), s = -1;
    for (var i = 0; i < n; i++) if (vis[i] && !vis[(i - 1 + n) % n]) { s = i; break; }
    if (s < 0) return [];
    var out = [];
    for (var j = 0; j < n; j++) { var k = (s + j) % n; if (!vis[k]) break; out.push(P(ring[k].p)); }
    return out;
  }

  function hull(points) {
    var p = points.slice().sort(function (a, b) { return a[0] - b[0] || a[1] - b[1]; });
    function cross(o, a, b) { return (a[0] - o[0]) * (b[1] - o[1]) - (a[1] - o[1]) * (b[0] - o[0]); }
    var lo = [], up = [], i;
    for (i = 0; i < p.length; i++) { while (lo.length >= 2 && cross(lo[lo.length - 2], lo[lo.length - 1], p[i]) <= 0) lo.pop(); lo.push(p[i]); }
    for (i = p.length - 1; i >= 0; i--) { while (up.length >= 2 && cross(up[up.length - 2], up[up.length - 1], p[i]) <= 0) up.pop(); up.push(p[i]); }
    lo.pop(); up.pop();
    return lo.concat(up);
  }

  function box(x0, x1, y0, y1, z0, z1) {
    var c = function (x, y, z) { return P([x, y, z]); };
    var faces = [
      { n: [0, 1, 0], q: [[x0, y1, z0], [x1, y1, z0], [x1, y1, z1], [x0, y1, z1]] },
      { n: [0, -1, 0], q: [[x0, y0, z0], [x1, y0, z0], [x1, y0, z1], [x0, y0, z1]] },
      { n: [0, 0, 1], q: [[x0, y0, z1], [x1, y0, z1], [x1, y1, z1], [x0, y1, z1]] },
      { n: [0, 0, -1], q: [[x0, y0, z0], [x1, y0, z0], [x1, y1, z0], [x0, y1, z0]] },
      { n: [1, 0, 0], q: [[x1, y0, z0], [x1, y1, z0], [x1, y1, z1], [x1, y0, z1]] },
      { n: [-1, 0, 0], q: [[x0, y0, z0], [x0, y1, z0], [x0, y1, z1], [x0, y0, z1]] }
    ];
    var vis = faces.filter(function (f) { return facing(f.n) > 1e-6; }).map(function (f) {
      return f.q.map(function (v) { return c(v[0], v[1], v[2]); });
    });
    var all = [];
    vis.forEach(function (f) { all = all.concat(f); });
    return { faces: vis, sil: hull(all) };
  }

  function lerp(tbl, d) {
    if (d <= tbl[0][0]) return tbl[0][1];
    for (var i = 1; i < tbl.length; i++) {
      if (d <= tbl[i][0]) { var a = tbl[i - 1], b = tbl[i]; return a[1] + (b[1] - a[1]) * (d - a[0]) / (b[0] - a[0]); }
    }
    return tbl[tbl.length - 1][1];
  }
  
  var T_WIDTH = [[2, 0.9], [3, 1.25], [4, 1.5], [5, 2], [8, 2], [10, 2.5], [12, 3]];
  var T_PLATE_L = [[2, 2.6], [3, 3.1], [4, 4], [6, 4.5], [8, 6.25], [12, 7.5]];
  var T_PLATE_D = [[2, 2.1], [3, 2.5], [4, 3.5], [6, 4], [8, 4.5], [12, 5.5]];

  function spec(D, K) {
    var px = function (inch, minPx) { return Math.max(inch, minPx / K); };  
    var s = { D: D, R: D / 2 };
    s.W = lerp(T_WIDTH, D);
    s.t = px(0.11 * D, 2.2);                 
    s.rh = 0.31 * D;                         
    s.rb = 0.215 * D;                        
    s.boss = px(0.145 * D, 2.8);             
    s.nut = px(0.08 * D, 1.7);               
    s.hp = px(0.035 * D + 0.04, 1);          
    s.legT = 0.03 * D + 0.04;
    s.legT2 = Math.max(0.04 * D, 1.6 / (K * SA));  
    s.lead = 0.2 * D;                        
    s.clear = 0.07 * D + 0.12;
    s.crownT = px(0.05 * D + 0.06, 2.2);     
    s.raceH = px(0.1 * D + 0.1, 2.8);
    s.plateT = px(0.035 * D + 0.06, 1.9);
    s.pl = lerp(T_PLATE_L, D);
    s.pd = lerp(T_PLATE_D, D);
    s.zl = s.W / 2 + s.hp + s.legT;          
    s.pd = Math.max(s.pd, 2 * s.zl + 0.3);
    s.rr = 0.36 * s.pl;                      
    s.yc0 = D + s.clear + s.crownT;          
    s.yr0 = s.yc0; s.yr1 = s.yr0 + s.raceH;
    s.yp0 = s.yr1; s.yp1 = s.yp0 + s.plateT;
    s.bolt = px(0.018 * D + 0.14, 1.2);      
    s.inset = Math.max(0.12 * s.pl, s.bolt + 0.12);
    s.lod = D * K;                           
    return s;
  }

  function model(D, K, wheelOnly) {
    var s = spec(D, K), R = s.R, ax = -s.lead, parts = [];
    
    var big = s.lod >= 90, mid = s.lod >= 20, coreOn = s.lod >= 60;
    var cy = s.yc0 - s.crownT;                

    function legOutline(z) {
      var top = [P([ax - s.boss, cy, z]), P([ax + s.boss, cy, z])];
      return hull(top.concat(pts(ringZ(ax, R, z, s.boss))));
    }

    if (!wheelOnly) {
      var far = legOutline(-s.zl);
      parts.push({ lines: [{ d: far, close: true, w: SW }], sil: far });
    }

    var front = pts(ringZ(ax, R, s.W / 2, R));
    var back = pts(ringZ(ax, R, -s.W / 2, R));
    var wheelSil = hull(front.concat(back));
    var core = pts(ringZ(ax, R, s.W / 2, R - s.t));
    var hubIn = pts(ringZ(ax, R, s.W / 2, s.rh));
    var hubOut = pts(ringZ(ax, R, s.W / 2 + s.hp, s.rh));
    var wl = [
      { tone: [wheelSil, core] },
      { d: wheelSil, close: true, w: SW },
      { d: front, close: true, w: SW2 }
    ];
    if (coreOn) wl.push({ d: core, close: true, w: SW2 });
    if (mid) wl.push({ d: hubOut, close: true, w: SW2 });
    if (big) wl.push({ d: hull(hubIn.concat(hubOut)), close: true, w: SW2 });
    if (big) wl.push({ d: pts(ringZ(ax, R, s.W / 2 + s.hp, s.rb)), close: true, w: SW2 });
    parts.push({ lines: wl, sil: wheelSil });
    if (wheelOnly) return { s: s, parts: parts, wheel: wheelSil, front: front, axle: P([ax, R, 0]) };

    var cx0 = Math.min(ax - s.boss, -s.rr * 0.9), cx1 = s.rr * 0.9;
    var cb = box(cx0, cx1, cy, s.yc0, -s.zl, s.zl);
    var cl = cb.faces.map(function (f) { return { d: f, close: true, w: SW2 }; });
    cl.push({ d: cb.sil, close: true, w: SW });
    parts.push({ lines: cl, sil: cb.sil });

    var near = legOutline(s.zl), nearL = [{ d: near, close: true, w: SW }];
    if (big) {  
      var inner = legOutline(s.zl - s.legT2);
      var legSil = hull(near.concat(inner));
      nearL = [{ d: legSil, close: true, w: SW }, { d: near, close: true, w: SW2 }];
      near = legSil;
    }
    parts.push({ lines: nearL, sil: near });

    var zn = s.zl + Math.max(0.03 * D, 0.6 / K), hex = [], nl = [];
    for (var i = 0; i < 6; i++) { var a = Math.PI / 6 + i * Math.PI / 3; hex.push(P([ax + s.nut * Math.cos(a), R + s.nut * Math.sin(a), zn])); }
    nl.push({ d: hex, close: true, w: mid ? SW2 : SW2 });
    if (big) nl.push({ d: pts(circle3([ax, R, zn], X, Y, s.nut * 0.45, 20)), close: true, w: SW2 });
    parts.push({ lines: nl, sil: hex });

    var rBot = ringY(0, s.yr0, 0, s.rr), rTop = ringY(0, s.yr1, 0, s.rr);
    var raceSil = hull(pts(rBot).concat(pts(rTop)));
    var rl = [{ d: raceSil, close: true, w: SW }, { d: frontArc(rBot), w: SW2 }];
    if (mid) rl.push({ d: frontArc(ringY(0, (s.yr0 + s.yr1) / 2, 0, s.rr)), w: SW2 });
    parts.push({ lines: rl, sil: raceSil });

    var pb = box(-s.pl / 2, s.pl / 2, s.yp0, s.yp1, -s.pd / 2, s.pd / 2);
    var pll = pb.faces.map(function (f) { return { d: f, close: true, w: SW2 }; });
    pll.push({ d: pb.sil, close: true, w: SW });
    var bx = s.pl / 2 - s.inset, bz = s.pd / 2 - s.inset;
    var holes = mid ? [[-bx, -bz], [bx, -bz], [-bx, bz], [bx, bz]] : [];
    holes.forEach(function (h) { pll.push({ d: pts(circle3([h[0], s.yp1, h[1]], X, Z, s.bolt, 28)), close: true, w: SW2 }); });
    if (big) pll.push({ d: pts(circle3([0, s.yp1, 0], X, Z, Math.max(0.05 * D, 1.4 / K), 28)), close: true, w: SW2 });
    parts.push({ lines: pll, sil: pb.sil });

    return { s: s, parts: parts, wheel: wheelSil, front: front, axle: P([ax, R, 0]) };
  }

  function bounds(m) {
    var b = { x0: 1e9, x1: -1e9, y0: 1e9, y1: -1e9 };
    m.parts.forEach(function (pt) { pt.sil.forEach(function (p) {
      b.x0 = Math.min(b.x0, p[0]); b.x1 = Math.max(b.x1, p[0]); b.y0 = Math.min(b.y0, p[1]); b.y1 = Math.max(b.y1, p[1]);
    }); });
    return b;
  }

  var kCache = {};
  function fitK(H) {
    if (kCache[H]) return kCache[H];
    var k = 7;
    for (var i = 0; i < 3; i++) { var b = bounds(model(12, k)); k = (H - PAD_TOP - PAD_FLOOR) / (b.y1 - b.y0); }
    return (kCache[H] = k);
  }

  function f1(v) { return Math.round(v * 10) / 10; }
  function inchLabel(n) {
    var w = Math.floor(n), fr = n - w, map = { 0.25: '1/4', 0.5: '1/2', 0.75: '3/4' };
    var key = Math.round(fr * 4) / 4;
    return (map[key] ? (w ? w + '-' : '') + map[key] : String(+n.toFixed(2))) + ' inch caster';
  }

  window.CCSizeIcon = function (inches, opts) {
    opts = opts || {};
    var D = +inches;
    if (!(D > 0)) return '';
    var Wd = opts.width || 120, H = opts.height || 110;
    var K = opts.k || fitK(H);
    var dim = opts.dim !== false, floor = opts.floor !== false;
    var m = model(D, K, !!opts.wheelOnly), b = bounds(m);
    var gap = 5 / K, tick = 3;                       
    var wb = { x0: 1e9, y1: -1e9, y0: 1e9 };
    m.front.forEach(function (p) { wb.x0 = Math.min(wb.x0, p[0]); wb.y1 = Math.max(wb.y1, p[1]); wb.y0 = Math.min(wb.y0, p[1]); });
    m.wheel.forEach(function (p) { wb.x0 = Math.min(wb.x0, p[0]); });
    var lx0 = dim ? Math.min(b.x0, wb.x0 - gap - tick / K) : b.x0;
    var floorIn = m.wheel.reduce(function (a, p) { return Math.min(a, p[1]); }, 1e9);
    var ox = Wd / 2 - (lx0 + b.x1) / 2 * K, oy = H - PAD_FLOOR;
    function sx(x) { return f1(ox + x * K); }
    function sy(y) { return f1(oy - (y - floorIn) * K); }
    function path(a, close) {
      return a.map(function (p, i) { return (i ? 'L' : 'M') + sx(p[0]) + ' ' + sy(p[1]); }).join('') + (close ? 'Z' : '');
    }

    var id = 'ccs' + (++seq).toString(36) + Math.random().toString(36).slice(2, 6);
    var defs = '', body = '', VE = ' vector-effect="non-scaling-stroke"';
    var parts = m.parts;
    for (var i = 0; i < parts.length; i++) {
      var nearer = parts.slice(i + 1);
      var mid = nearer.length ? id + 'm' + i : '';
      if (mid) {
        defs += '<mask id="' + mid + '" maskUnits="userSpaceOnUse" x="0" y="0" width="' + Wd + '" height="' + H + '">' +
          '<rect width="' + Wd + '" height="' + H + '" fill="#fff"/>' +
          nearer.map(function (q) { return '<path d="' + path(q.sil, true) + '" fill="#000"/>'; }).join('') + '</mask>';
      }
      var g = '';
      parts[i].lines.forEach(function (l) {
        if (l.tone) {
          g += '<path class="ccs-tone" d="' + path(l.tone[0], true) + path(l.tone[1], true) + '" fill="currentColor" fill-opacity=".09" fill-rule="evenodd" stroke="none"/>';
          return;
        }
        if (!l.d || l.d.length < 2) return;
        g += '<path d="' + path(l.d, l.close) + '"' + (l.w !== SW ? ' stroke-width="' + l.w + '"' : '') + VE + '/>';
      });
      body += mid ? '<g mask="url(#' + mid + ')">' + g + '</g>' : g;
    }

    var extra = '';
    if (floor) {
      var fx0 = wb.x0 - 0.12 * D - 3 / K, fx1 = b.x1 + 3 / K;
      extra += '<path class="ccs-floor" d="M' + sx(fx0) + ' ' + sy(floorIn) + 'H' + sx(fx1) + '" stroke-width="1" stroke-opacity=".4"' + VE + '/>';
    }
    if (dim) {
      var dx = sx(wb.x0 - gap), top = sy(floorIn + (wb.y1 - wb.y0)), bot = sy(floorIn);
      var topPt = m.front.reduce(function (a, p) { return p[1] > a[1] ? p : a; }, [0, -1e9]);
      extra += '<g class="ccs-dim" stroke="' + MAROON + '" stroke-width="1" stroke-linecap="butt">' +
        '<path d="M' + dx + ' ' + top + 'V' + bot + '"' + VE + '/>' +
        '<path d="M' + f1(dx - tick) + ' ' + top + 'H' + f1(dx + tick) + 'M' + f1(dx - tick) + ' ' + bot + 'H' + f1(dx + tick) + '"' + VE + '/>' +
        '<path d="M' + f1(dx + tick + 1.5) + ' ' + top + 'H' + f1(sx(topPt[0]) - 2) + '" stroke-width=".75" stroke-dasharray="1.5 1.5" stroke-opacity=".8"' + VE + '/>' +
        '</g>';
    }

    var label = opts.label || inchLabel(D);
    return '<svg class="' + (opts.cls || 'cc-size-ico') + '" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ' + Wd + ' ' + H + '" width="' + Wd + '" height="' + H +
      '" role="img" aria-label="' + label + '" data-in="' + D + '" fill="none" stroke="currentColor" stroke-width="' + SW +
      '" stroke-linecap="square" stroke-linejoin="round">' + (defs ? '<defs>' + defs + '</defs>' : '') + extra + body + '</svg>';
  };
  window.CCSizeIcon.pxPerInch = fitK;
})();
